module.exports = __webpack_public_path__ + "static/media/icono_agua.8ecc7622.svg";